var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
class RebillyWrapper {
    constructor(organizationId, publishedKey, secretKey, sandbox) {
        this.secretKey = secretKey;
        this.publishedKey = publishedKey;
        this.organizationId = organizationId;
        this.sandbox = !!sandbox;
    }
    get apiDomain() {
        return this.sandbox ? RebillyWrapper.sandboxDomain : RebillyWrapper.apiDomain;
    }
    get headers() {
        var _a, _b;
        return {
            Authorization: (_a = this.secretKey) !== null && _a !== void 0 ? _a : this.publishedKey,
            'Organization-Id': this.organizationId,
            'REB-APIKEY': (_b = this.secretKey) !== null && _b !== void 0 ? _b : this.publishedKey,
        };
    }
    createPaymentToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.apiDomain}/tokens`, params, {
                headers: this.headers,
            })).data;
        });
    }
    createOrder(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return (yield axios.post(`${this.apiDomain}/subscriptions?expand=recentInvoice,initialInvoice`, params, {
                    headers: this.headers,
                })).data;
            }
            catch (ex) {
                console.log(`ERROR: ${JSON.stringify(ex.response.data)}`);
                throw ex;
            }
        });
    }
    createInvoice(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.apiDomain}/invoices`, params, {
                headers: this.headers,
            })).data;
        });
    }
    createTransaction(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.apiDomain}/transactions`, params, {
                headers: this.headers,
            })).data;
        });
    }
    createCustomer(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${this.apiDomain}/customers`, params, {
                headers: this.headers,
            })).data;
        });
    }
}
RebillyWrapper.sandboxDomain = 'https://api-sandbox.rebilly.com';
RebillyWrapper.apiDomain = 'https://api.rebilly.com';
export default RebillyWrapper;
